import { Controller } from "@hotwired/stimulus"

// Floating "back to top" button: shown after scrolling down, scrolls up on click.
export default class extends Controller {
  static values = { offset: { type: Number, default: 400 } }

  connect() {
    this.ticking = false
    this.onScroll = () => {
      if (this.ticking) return
      this.ticking = true
      requestAnimationFrame(() => { this.update(); this.ticking = false })
    }
    window.addEventListener("scroll", this.onScroll, { passive: true })
    this.update()
  }

  disconnect() {
    window.removeEventListener("scroll", this.onScroll)
  }

  update() {
    const visible = window.scrollY > this.offsetValue
    this.element.classList.toggle("c64-scroll-top--visible", visible)
    // keep it out of the tab order while hidden
    this.element.tabIndex = visible ? 0 : -1
  }

  scrollUp() {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches
    window.scrollTo({ top: 0, behavior: reduce ? "auto" : "smooth" })
  }
}
